import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Caption, Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const eras = [{
  name: 'General AI',
  quote: '“Ask a question”'
}, {
  name: 'AI copilot',
  quote: '“Complete a task”'
}];
const parts = ['Data', 'Models', 'Memory', 'Assets', 'Workflows', 'Feedback'];
function Arrow() {
  return <span className="self-center text-[1.8cqw] text-white/30" aria-hidden data-id="element-409" data-mp="2l194fu2j02k0">
      →
    </span>;
}
export function SystemOfIntelligenceSlide() {
  return <Slide data-id="element-410" data-mp="2ttkyrr0rga59">
      <Eyebrow data-id="element-411" data-mp="2tu31n6hxhmm5">From chatbot to institutional intelligence</Eyebrow>
      <Title className="mt-[2.2cqh] max-w-[72%]" data-id="element-412" data-mp="2p2cjiecr1uk6">
        Chatbots answer questions. DiligenceGPT™ builds institutional intelligence.
      </Title>

      <div className="mt-auto flex items-stretch gap-[1.6cqw]" data-id="element-413" data-mp="21bfi3vikyfn6">
        {eras.map((era, i) => <React.Fragment key={era.name} data-id="element-414" data-mp="1xadgj816xri1" data-mpi={i}>
            {i > 0 && <Arrow data-id="element-415" data-mp="20zr0eglfz80v" />}
            <Reveal delay={0.06 * i} className="flex w-[19cqw] shrink-0 flex-col border border-white/10 p-[1.6cqw]" data-id="element-416" data-mp="21094fzeciqjc">
              <Label data-id="element-417" data-mp="25x9bacj0rxbi">Stage {i + 1}</Label>
              <p className="mt-[1.6cqh] text-[2.2cqw] leading-none text-[#AEB7C7]" style={SERIF} data-id="element-418" data-mp="25w7ppe4dnsfj">
                {era.name}
              </p>
              <p className="mt-auto pt-[8cqh] text-[1.2cqw] text-[#8B95A8]" data-id="element-419" data-mp="2fnc2q8aht37q">{era.quote}</p>
            </Reveal>
          </React.Fragment>)}

        <Arrow data-id="element-420" data-mp="1i2zlskguhh35" />

        <Reveal delay={0.16} className="flex flex-1 flex-col border border-[#3B8CFF]/50 bg-[#3B8CFF]/[0.07] p-[1.8cqw]" data-id="element-421" data-mp="1mzpx6uhpfoi8">
          <Label tone={INK.blue} data-id="element-422" data-mp="1ryjeyz40y1o7">DiligenceGPT™</Label>
          <p className="mt-[1.6cqh] text-[2.6cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-423" data-mp="1s0vw5a1yk807">
            Run the institutional process
          </p>
          <div className="mt-auto grid grid-cols-6 gap-[0.6cqw] pt-[4cqh]" data-id="element-424" data-mp="33ercun8igotj">
            {parts.map(p => <span key={p} className="border border-white/15 py-[1.2cqh] text-center text-[0.98cqw] text-[#E3E8F1]" data-id="element-425" data-mp="38bq2ash8c7le">
                {p}
              </span>)}
          </div>
        </Reveal>
      </div>

      <Caption className="mt-[3cqh] max-w-[64%]" data-id="element-426" data-mp="13b6tmk9d2mc3">
        Every better foundation model makes the system around it more capable —
        StartupFuel builds alongside model providers, not against them.
      </Caption>
    </Slide>;
}